import { Container, TextField, Button, Card, Typography, CircularProgress, Divider, Tooltip } from '@mui/material';
import { useEffect } from 'react';

const AboutUs = () => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [])
  return (
    <div style={{ minHeight: 'calc(100vh - 340px)' }}>
      <div className="container max-w-7xl mx-auto px-4 md:px-8 h-full">

        <Typography variant="h4" className="font-bold">About Us</Typography>
        <p className="mt-4 leading-8">
          At EIQdigital, we are leading the transformation of energy management by harnessing cutting-edge technologies to make energy decisions clearer and more accessible. Our mission is to empower consumers, businesses, and startups with the insights and tools they need to make sustainable, informed choices—driving a more equitable and efficient energy future.
        </p>
        <p className="mt-4 leading-8">
          With deep expertise in both retail energy and digital capabilities, we are uniquely positioned as a leader in developing digital products that meet business needs while advancing societal goals, particularly in addressing climate change.
        </p>
        <p className="mt-4 leading-8">
          Located in Houston TX, the "Energy Capital of the World" EIQdigital is at the forefront of the digital transformation, leveraging AI-driven data and products to lead the way toward a sustainable energy transition.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;